import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-info-box',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './info-box.component.html',
    styleUrls: ['./info-box.component.scss'],
})
export class InfoBoxComponent {
    isExpanded = false;

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {
        this.matIconRegistry.addSvgIcon(
            'document_partially_unprocessed',
            this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/document_partially_unprocessed.svg')
        );
    }

    toggleExpand(): void {
        this.isExpanded = !this.isExpanded;
    }
}